import React from 'react'
import Aboutus from '../components/about/Aboutus'

const About = () => {
  return (
    <Aboutus/>
  )
}

export default About